import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from "../config";

// Client-side SHA-256 password generator (guinness salt)
async function generateDeterministicKey(domain) {
    if (!domain.trim()) return '';
    const salt = 'guinness';
    const encoder = new TextEncoder();
    const firstBuf = await window.crypto.subtle.digest('SHA-256', encoder.encode(domain.trim()));
    const firstPass = Array.from(new Uint8Array(firstBuf)).map(b => b.toString(16).padStart(2, '0')).join('');
    const secondBuf = await window.crypto.subtle.digest('SHA-256', encoder.encode(firstPass + salt));
    const base64 = btoa(String.fromCharCode(...new Uint8Array(secondBuf)));
    const map = { '+': '_', '/': '@', '=': '-' };
    return base64.replace(/[+/=]/g, m => map[m]).substring(0, 23) + '!';
}

const MdpGenDomain = () => {

    // ── FTP section ──────────────────────────────────────────────
    const [host, setHost] = useState('');
    const [hosts, setHosts] = useState([]);
    const [usernameGenerated, setUsernameGenerated] = useState('');
    const [passGenerated, setPassGenerated] = useState('');

    useEffect(() => {
        axios
            .post(`${API_BASE_URL}/get_hosts`)
            .then((res) => {
                if (res.data.status === 'ok') setHosts(res.data.hosts);
            })
            .catch((err) => console.error('Failed to fetch hosts:', err));
    }, []);

    const generateFtpPassword = (selectedHost) => {
        if (!selectedHost) return;
        axios
            .post(`${API_BASE_URL}/generate_password`, { domain: selectedHost })
            .then((res) => {
                setUsernameGenerated(res.data.username);
                setPassGenerated(res.data.password);
            })
            .catch((err) => console.error(err));
    };

    // ── Generic domain generator ─────────────────────────────────
    const [domain, setDomain] = useState('');
    const [domainPass, setDomainPass] = useState('');
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!domain.trim()) { setDomainPass(''); return; }
        const timer = setTimeout(async () => {
            const pwd = await generateDeterministicKey(domain);
            setDomainPass(pwd);
        }, 200);
        return () => clearTimeout(timer);
    }, [domain]);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(domainPass).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    return (
        <div className="display-flex flex-direction-column gap-30">

            {/* ── Generic password generator ── */}
            <div className="display-flex flex-direction-column gap-15">
                <h4 className="mt-0 mb-10 color-third">Générateur de mot de passe</h4>
                <p className="mt-0 mb-15" style={{ fontSize: '.85rem', opacity: .7 }}>
                    Entrez un domaine ou une clé pour générer le mdp associé.
                </p>
                <label>Domaine (ne pas oublier le .ch)</label>
                <input
                    type="text"
                    className="input"
                    placeholder="ex: client.com  ou  visu.solution-digitale.ch/mon-visu"
                    value={domain}
                    onChange={e => setDomain(e.target.value)}
                    autoComplete="off"
                />
                {domainPass && (
                    <div className="display-flex align-items-center gap-10 mt-10">
                        <input type="text" value={domainPass} readOnly className="input" style={{ flex: 1, fontFamily: 'monospace' }} />
                        <button
                            className="btn btn-primary"
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={copyToClipboard}
                        >
                            {copied ? '✅ Copié !' : '📋 Copier'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MdpGenDomain;